import Vue from 'vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)

// Attach prototype helpers
import './plugins/helpers/index.js'

// axios with api base path
import api from './api/index.js'
Vue.prototype.$api = api

// axios with global accessibility
import http from './plugins/http.js'
Vue.prototype.$http = http

// directives
import './plugins/directives.js'

// Theme Configurations
import '../themeConfig.js'

// Globally Registered Components
import './plugins/globalComponents.js'

// Styles: SCSS & CSS
import './assets/scss/main.scss'
import './assets/css/main.css'

// Tailwind
import '@/assets/css/tailwind.css'

// Vuex Store
import { initializer, store } from './store/index.js'

// Vue Router
import router from './store/router/config/router'

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

// Custom text filters
import './plugins/filters'

// Validation and additional global rules
import VeeValidate from 'vee-validate'
import './plugins/validationRules'
Vue.use(VeeValidate, {
    events: 'input|blur'
})

// Custom mixins
import mixins from './plugins/mixins'

// Feather font icon
require('./assets/css/iconfont.css')

// PrismJS, used for syntax highlighting code snippets on your page.
// Also used for escaping html blocks for display of code in browser
// import 'prismjs'
// import 'prismjs/themes/prism-tomorrow.css'

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

import App from './App.vue'
Vue.config.productionTip = false

initializer()
    .then(() => {
        Vue.mixin(mixins)

        new Vue({
            router,
            store,
            render: (h) => h(App)
        }).$mount('#app')
    })
    .catch((error) => {
        console.error(`FATAL ERROR: ${error}`)
    })
